/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantVlcrProvisionEdr { 
    /**
     * Region in which Provision EDR org id is hosted
     */
    edr_region?: string;
}

